import { produce } from "immer";
import * as RBConstants from "./RBConstants";

const assign = Object.assign || require("object.assign");

const initialState = {
  isRBDataFetched: false,
  isRBDataFetching: false,
  isRBDataFailed: false,
  isRBTestNameFetching: false,
  isRBTestNameFetched: false,
  isRBTestNameFailed: false,
  isRBLotSelected:false,
  RBTestName: [],
  selectedFirstTestName: null,
  rbData: [],
  CalibrationLotBeans: [],
  isRBConfigFetched: false,
  isRBConfigFetching: true,
  isRBConfigFailed: false,
  RBConfig: [],
  selectedRBLotNumber: [],
  selectedTestName: null,
  fromDate: null,
  toDate: null
};

export default function RBReducer(state = initialState, action) {
  switch (action.type) {
    case RBConstants.RB_DATA_STATE_ADD: {
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_DATA_STATE_REMOVE: {
      const newState = produce(state, (draft) => {
        if (draft[action.payload]) {
          delete draft[action.payload];
        }
      });
      return assign({}, newState);
    }
    case RBConstants.RB_DATA_FETCHING: {
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
          isRBDataFetched: false,
          isRBDataFetching: true,
          isRBDataFailed: false,
          rbData: [],
          CalibrationLotBeans: [],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_DATA_FETCHED: {
      const newState = produce(state, (draft) => {
        const rbdata = action.payload.newState.result.rbdata;
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          isRBDataFetched: true,
          isRBDataFetching: false,
          isRBDataFailed: false,
          RBTestResult: rbdata?.rbTestResult || [],
          CalibrationLotBeans: rbdata?.calibrationLotBeans || [],
          rbData: rbdata?.rbTestResult || [],
          selectedFirstTestName: rbdata?.rbTestResult?.[0]?.testName,
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_DATA_FETCHING_FAILED: {
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
          isRBDataFetched: false,
          isRBDataFetching: false,
          isRBDataFailed: true,
          rbData: [],
          CalibrationLotBeans: [],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_LOT_DATA: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          selectedRBLotNumber: action.payload.newState,
        };
      });

      return assign({}, state, newState);
    }

    case RBConstants.RB_TEST_NAME_FETCHING: {
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
          isRBTestNameFetched: false,
          isRBTestNameFetching: true,
          isRBTestNameFailed: false,
          RBTestName: [],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_TEST_NAME_FETCHED: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          isRBTestNameFetched: true,
          isRBTestNameFetching: false,
          isRBTestNameFailed: false,
          RBTestName: action.payload.newState.result,
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_TEST_NAME_FETCHING_FAILED: {
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
          isRBTestNameFetched: false,
          isRBTestNameFetching: false,
          isRBTestNameFailed: true,
          RBTestName: [],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_TEST_NAME: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          selectedTestName: action.payload.newState,
          rbData: [],
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_FROM_DATE: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          fromDate: action.payload.newState,
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_TO_DATE: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          toDate: action.payload.newState,
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_CONFIG_FETCHING:
      const newState = produce(state, (draft) => {
        draft[action.payload] = {
          ...draft[action.payload],
          isRBConfigFetched: false,
          isRBConfigFetching: true,
          isRBConfigFailed: false,
          RBConfig: [],
        };
      });

    case RBConstants.RB_CONFIG_FETCHED: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          isRBConfigFetched: true,
          isRBConfigFetching: false,
          isRBConfigFailed: false,
          RBConfig: action.payload.newState?.result?.rbReportModels,
        };
      });
      return assign({}, state, newState);
    }

    case RBConstants.RB_LOT_SELECTED: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          isRBLotSelected: action.payload.newState.isRBLotSelected,
          rbDataActual:action.payload.newState.rbDataActual
        };});
        return assign({}, state, newState);
    }

    case RBConstants.RB_REAGENT_NAME_SELECTED: {
      const newState = produce(state, (draft) => {
        draft[action.payload.deviceId] = {
          ...draft[action.payload.deviceId],
          isRBReagentNameSelected: action.payload.newState
        };});
        return assign({}, state, newState);
    }


    default:
      return state;
  }
}
